import React, { } from 'react';
import { RouteChildrenProps, } from 'react-router-dom';
import { Modal, message, Spin, Button, Tag, Space } from 'antd';
import api, { GetExhibitionWorkRes, GetExhibitionWorkListParameters, DeleteExhibitionWorkParameters, GetAssetParameters, GetAssetRes } from '../../api';
import JJ_Table from '../../components/JJ_Table';
import ExhibitionWorkEditAndAdd, { Type } from './ExhibitionWorkAdd';
import { connect, ConnectedProps } from 'react-redux';
import { getExhibitionWorkColumns, ExhibitionWorkColumnData } from '../../table-columns/ExhibitionWork';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ActionUserRes } from '../../actions/ActionUser';
import tool from '../../tool';
import { PlusOutlined } from '@ant-design/icons';

const { confirm } = Modal;

type EditAndAddModalType = Type

interface PageState {
  initLoading: boolean
  isSpinLoading: boolean
  editAndAddModal: {
    show: boolean
    key?: string
  } & EditAndAddModalType
}
interface Props {
}


interface Page {
  tableRef?: JJ_Table<GetExhibitionWorkRes> | null
}


type PageProps = Props & RouteChildrenProps & ConnectedProps<typeof connector>

interface RootState {
  user: ActionUserRes
}

const mapState = (state: RootState) => ({
  user: state.user,

})

const mapDispatch = {

}

const connector = connect(
  mapState,
  mapDispatch
)

class ExhibitionWorkList extends React.Component<PageProps, PageState> implements Page {

  constructor (props: Readonly<PageProps>) {
    super(props);
    this.state = {
      isSpinLoading: true,
      initLoading: true,
      editAndAddModal: {
        id: '',
        type: 'edit',
        show: false,
        key: new Date().toString()
      }
    }
  }
  tableRef?: JJ_Table<ExhibitionWorkColumnData> | null
  componentDidMount() {
    this._initData()
  }


  _getExhibitionWorkList = async (params: GetExhibitionWorkListParameters) => {
    const res = await api.GetExhibitionWorkList(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }

  _getAsset = async (params: GetAssetParameters) => {
    const res = await api.GetAsset(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }

  _deleteExhibitionWork = async (params: DeleteExhibitionWorkParameters) => {
    const res = await api.DeleteExhibitionWork(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }


  _initData = async () => {
    try {
      this.setState({
        isSpinLoading: true,
        initLoading: true
      })

      this.setState({
        isSpinLoading: false,
        initLoading: false,
      })
    } catch (error: any) {
      this.setState({
        isSpinLoading: false,
        initLoading: false
      })
    }
  }
  render() {

    return (
      <div id="ExhibitionWorkList"
      >
        <Modal
          maskClosable={false}
          title={this.state.editAndAddModal.type === 'edit' ? '編輯展覽作品' : '新建展覽作品'}
          visible={this.state.editAndAddModal.show}
          footer={null}
          onCancel={() => this.setState(state => ({
            editAndAddModal: { ...state.editAndAddModal, show: false }
          }))}
          width={'85%'}
        >
          {this.state.editAndAddModal.key && (
            <ExhibitionWorkEditAndAdd
              {...this.state.editAndAddModal}
              onFinish={async (props) => {
                this.setState(state => ({
                  editAndAddModal: { ...state.editAndAddModal, show: false }
                }))
                switch (props.type) {
                  case 'add': {
                    this.tableRef && await this.tableRef.refreshData()
                    message.success(`添加成功`)
                  }
                    break
                  case 'edit': {
                    this.tableRef && await this.tableRef.refreshData()
                    message.success(`編輯成功`)
                  }
                }

              }}
            />
          )}

        </Modal>

        <Space>

          <Button
            type='primary'
            style={{ marginBottom: 5 }}
            onClick={() => {
              this.setState(state => ({
                editAndAddModal: {
                  ...state.editAndAddModal,
                  show: true,
                  key: new Date().toString(),
                  type: 'add',
                }
              }))
            }}
            icon={<PlusOutlined />}
          >
            {`添加`}
          </Button>

        </Space>


        <Spin spinning={this.state.initLoading}>
          {!this.state.initLoading && (
            <Spin spinning={this.state.isSpinLoading}>

              <JJ_Table<ExhibitionWorkColumnData, {
                order?: 'ASC' | 'DESC'
              }>
                ref={ref => this.tableRef = ref}
                isSearchText={true}
                sourceItems={[
                  {
                    type: 'select',
                    defaultValue: 'DESC',
                    key: 'order',
                    span: 4,
                    options: [
                      {
                        value: 'ASC',
                        name: '升序',
                        disabled: false,
                      },
                      {
                        value: 'DESC',
                        name: '降序',
                        disabled: false,
                      },
                    ]
                  },
                ]}
                columns={getExhibitionWorkColumns({
                  user: this.props.user,
                  onAction: (key, record) => {
                    switch (key) {
                      case 'delete': {
                        const name = tool.local.formatMessage({ user: this.props.user, data: record.title })
                        confirm({
                          title: `是否刪除(${name})`,
                          icon: <ExclamationCircleOutlined />,
                          okText: 'Yes',
                          okType: 'danger',
                          cancelText: 'No',
                          onOk: async () => {
                            try {
                              await this._deleteExhibitionWork({ id: record.id })
                              this.tableRef && this.tableRef.refreshData()
                              message.success(`${name} 删除成功`)
                            } catch (error: any) {
                              message.error(`${name} 删除失败 [${error?.message}]`);
                            }
                          },
                          onCancel() {
                          },
                        });
                      }
                        break
                      case 'edit': {
                        this.setState(state => ({
                          editAndAddModal: { ...state.editAndAddModal, show: true, type: 'edit', id: record.id, key: new Date().toString() }
                        }))
                      }
                    }
                  }
                })}
                title={'展覽作品列表'}
                onDataSource={async (body) => {
                  const { sourceItemBody } = body

                  const params: {
                    order?: GetExhibitionWorkListParameters['order']
                  } = {}
                  if (sourceItemBody) {
                    params.order = sourceItemBody.order || undefined
                  }
                  const res = await this._getExhibitionWorkList({
                    ...body,
                    ...params,
                  })
                  return {
                    data: await Promise.all(
                      res.data.map(async item => {
                        let assets: GetAssetRes[] | undefined

                        if (item.assetId) {
                          const assetRes = await this._getAsset({ id: item.assetId })
                          assets = [assetRes]
                        }

                        return {
                          ...item,
                          assets,
                        }
                      })
                    ),
                    totalCount: res.count,
                  }
                }}
              />

            </Spin>

          )}
        </Spin>

      </div>
    )
  }

}
export default connector(ExhibitionWorkList)

